import Component from "gia/Component";
import Splide from "@splidejs/splide";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.buildSlideshow();
  }

  buildSlideshow() {
    // console.log(this.DOM.view);
    this.slideshow = new Splide(this.ref.slider[0], {
      arrows: false,
      gap: 9,
      interval: 7000,
      padding: { left: 35, right: 35 },
      pauseOnFocus: false,
      pauseOnHover: false,
      pagination: false,
      fixedHeight: 70,
      fixedWidth: 192,
      perPage: 1,
      perMove: 1,
      rewind: true,
      rewindByDrag: true,
      speed: 700,
      type: "slide",
      omitEnd: false,
      arrowPath:
        "M2.567.662c-.177.192-.323.355-.326.363-.004.011 4.945 4.624 5.059 4.714.034.027-.088.143-2.509 2.391-1.4 1.3-2.548 2.369-2.551 2.377-.011.026.66.731.683.717a718.59 718.59 0 0 0 2.952-2.735l2.93-2.721-.065-.056c-.036-.031-1.357-1.257-2.936-2.724A328.794 328.794 0 0 0 2.91.317c-.012-.002-.167.153-.343.345",
      breakpoints: {
        640: {
          arrows: false,
          fixedHeight: 64,
          fixedWidth: 192,
          padding: { left: 12, right: 12 },
          perPage: 1,
        },
      },
    });
    this.ref.prev[0].addEventListener("click", () => this.slideshow.go("-"));
    this.ref.next[0].addEventListener("click", () => this.slideshow.go("+"));
    this.ref.next[0].addEventListener("click", () => {
      console.log("ckick");
    });
    this.slideshow.mount();
  }

  unmount() {}
}
